
import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { DeviceType, AppModule } from "@/store/modules/app";
import { SettingsModule } from "@/store/modules/settings";
import { AppMain, Navbar, Sidebar, TagsView } from "./components";
import ResizeMixin from "./mixin/resize";

@Component({
  name: "Layout",
  components: {
    AppMain,
    Navbar,
    Sidebar,
    TagsView
  }
})
export default class extends mixins(ResizeMixin) {
  get classObj() {
    return {
      hideSidebar: !this.sidebar.opened,
      openSidebar: this.sidebar.opened,
      withoutAnimation: this.sidebar.withoutAnimation,
      mobile: this.device === DeviceType.Mobile,
      hasTagsView: this.showTagsView
    };
  }

  get showTagsView() {
    return SettingsModule.showTagsView;
  }

  get fixedHeader() {
    return SettingsModule.fixedHeader;
  }

  private handleClickOutside() {
    AppModule.CloseSideBar(false);
  }
}
